import { ToastType } from '@hglobal/common';

import { AUTHORIZATION_ERROR_CODE, EXPIRED_TOKEN_ERROR_CODE } from './auth.constants';

export enum RegistrationStatus {
  Active = 'active',
  Blocked = 'blocked',
  WaitingForEmailApprove = 'waiting for email approve',
  WaitingForPhoneApprove = 'waiting for phone approve',
  WaitingForEnterData = 'waiting for enter data',
  WaitingForAccountApprove = 'waiting for account approve',
  InviteSent = 'invite sent',
}

export enum TwoFactorStatus {
  WaitForApprove = 'wait for approve',
  Enable = 'enable',
  Disable = 'disable',
  Active = 'active',
}

export enum InviteTokenStatus {
  Registered = 1,
  Unregistered,
}

export const logOutErrorToastData = { type: ToastType.Warning, message: "You've been log out from the system. Please log in again." };
export const logOutCodesCollection = new Map([
  [AUTHORIZATION_ERROR_CODE, 'Authorization error code from backend'],
  [EXPIRED_TOKEN_ERROR_CODE, 'Expired token error code from backend'],
]);
